// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content{padding-bottom:32px!important}.app-content>.v-content__wrap{display:flex;flex-direction:column}", ""]);
// Exports
module.exports = exports;
